import styled from "styled-components";

export const GamesOpenSessionRecordGameIconDefaultBox = styled.div`
    width: 120px;
    height: 150px;
    & > img {
        width: auto;
        max-height: 100%;
    }
`